import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { scrollToTop } from 'utils'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function MobileAppLayout({ children }) {
  const { pathname } = useLocation()

  useEffect(() => {
    scrollToTop()
  }, [pathname])

  return (
    <div className="mobile-layout">
      <main id="main-content">{children}</main>
    </div>
  )
}

MobileAppLayout.propTypes = propTypes

export default MobileAppLayout
